import { Injectable, ElementRef } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';

import { Store, select } from '@ngrx/store';
import { LayoutActions } from 'app/layout';
import { selectTotalScreenSize } from 'app/layout/layout.selector';
import { AppState } from 'app/core/core.state';
import { ScreenSize } from 'app/models/common/screenSize';

@Injectable()
export class LayoutService {

  public screen = new ScreenSize();
  public totalWindowWidth: number;
  public totalWindowHeight: number;

  constructor(
    private store: Store<AppState>,
    private breakPointObserver: BreakpointObserver
  ) {
    this.recalculate();
    fromEvent(window, 'resize')
      .subscribe(() => {
        this.recalculate();
      });
  }

  recalculate() {
    this.store.dispatch(LayoutActions.setTotalWindowWidth({ totalWindowWidth: window.innerWidth }));
    this.store.dispatch(LayoutActions.setTotalWindowHeight({ totalWindowHeight: window.innerHeight }));
    this.setScreenSize();
  }

  setScreenSize() {
    this.store.pipe(select(selectTotalScreenSize)).subscribe(screen => {
      if (screen.xs || screen.md || screen.lg)
        this.screen = screen;
    });

    this.breakPointObserver
      .observe(['(max-width:599px)']).subscribe(state => {
        if (state.matches) {
          this.screen = new ScreenSize();
          this.screen.xs = true;
          this.store.dispatch(LayoutActions.setTotalScreenSize({ totalScreenSize: this.screen }))
        }
      });
    this.breakPointObserver
      .observe(['(min-width:600px) and (max-width:1279px)']).subscribe(state => {
        if (state.matches) {
          this.screen = new ScreenSize();
          this.screen.md = true;
          this.store.dispatch(LayoutActions.setTotalScreenSize({ totalScreenSize: this.screen }))
        }
      });
    this.breakPointObserver
      .observe(['(min-width:1280px)']).subscribe(state => {
        if (state.matches) {
          this.screen = new ScreenSize();
          this.screen.lg = true;
          this.store.dispatch(LayoutActions.setTotalScreenSize({ totalScreenSize: this.screen }))
        }
      });
  }

  setSidenavOpened(value: boolean) {
    this.store.dispatch(LayoutActions.setSidenavOpened({ sidenavOpened: value }));
  }

  setPopoverWidth(value) {
    this.store.dispatch(LayoutActions.setPopoverWidth({ popoverWidth: value }));
  }

  setToolbarZindex(value: number) {
    this.store.dispatch(LayoutActions.setToolbarZindex({ toolbarZindex: value }));
  }

  setDockOriginReference(value: ElementRef) {
    this.store.dispatch(LayoutActions.setGlobalReference({ globalReference: value }));
  }
}
